// import React from 'react';

import { useLocation } from 'react-router-dom';
import ProjectsYearFilter from '../ProjectsYearFilter/ProjectsYearFilter';

const ProjectsAsideListControl = () => {
  const { pathname } = useLocation();
  return <div>{pathname === '/projects' && <ProjectsYearFilter data={pathname.replace('/projects/', '')} />}</div>;
};

export default ProjectsAsideListControl;
